import type { Editor } from 'grapesjs';
import { CrossTabClipboard } from '../services/CrossTabClipboard';

let clipboard: CrossTabClipboard | null = null;

export const crossTabPasteCommand = {
  run(editor: Editor) {
    // Инициализируем сервис clipboard, если он еще не инициализирован
    if (!clipboard) {
      clipboard = new CrossTabClipboard(editor);
    }

    // Проверяем, есть ли данные в localStorage
    if (!clipboard.hasData()) {
      console.info('[CrossTabPaste] No data in clipboard');

      return;
    }

    try {
      const pastedComponents = clipboard.paste();

      if (!pastedComponents || pastedComponents.length === 0) {
        console.info('[CrossTabPaste] No components were pasted');
      }
    } catch (error) {
      console.info('[CrossTabPaste] Error pasting:', error);
    }
  },
};

export const initializeCrossTabPaste = (editor: Editor) => {
  // Добавляем нашу кастомную команду вставки
  editor.Commands.add('cross-tab-paste', crossTabPasteCommand);
};
